import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
  Paper,
  Rating,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddShowRoomModal from "../components/AddShowRoomModal";
import ReactQuill from "react-quill";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast, ToastContainer } from "react-toastify";
import Tooltip from "@mui/material/Tooltip"; //

const ShowroomAccordian = (props) => {
  const { title, storeType, data, setData } = props;

  const storeId = useParams()?.id;

  const selectedCity = useSelector(({ city }) => city?.citiesMap?.[storeId]);

  console.log("this is showroom accordian selected city", selectedCity);

  const [selectedStore, selectStore] = useState(null);
  const [showStoreModal, setShowStoreModal] = useState(false);

  const handleModal = useCallback((show = false, selectedObj) => {
    show = typeof show === "boolean" && show;
    setShowStoreModal(show);
    selectStore(selectedObj);
  }, []);

  const handleStore = useCallback((showroomObj) => {
    let { index, ...rest } = showroomObj;

    if (index !== undefined) {
      setData((prev) => ({
        ...prev,
        showrooms: (prev?.showrooms || []).map((obj, i) =>
          i === index ? rest : obj,
        ),
      }));
    } else {
      setData((prev) => ({
        ...prev,
        showrooms: [...(prev?.showrooms || []), showroomObj],
      }));
    }
  }, []);

  const handleRemove = useCallback((index) => {
    setData((prev) => ({
      ...prev,
      showrooms: (prev?.showrooms || []).filter((_, i) => i !== index),
    }));
  }, []);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e?.target?.checked ?? e;

      setData((preState) => ({ ...preState, [name]: value }));
    },
    [setData],
  );

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography fontWeight={"600"}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="form_comp">
            <label htmlFor="title">Title</label>
            <ReactQuill
              placeholder="Enter title"
              value={data?.title}
              onChange={handleChange("title")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="form_comp">
            <label htmlFor="title">Description</label>
            <ReactQuill
              placeholder="Enter description"
              value={data?.description}
              onChange={handleChange("description")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="btn-container mt15">
            <Button
              variant="contained"
              className="bordered-button float-right"
              onClick={() => handleModal(true)}
            >
              + Add Show Room
            </Button>
          </div>

          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 650, px: 2 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Showroom name
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Address
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Zoho ID
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Rating
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Edit
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.showrooms?.map((showroom, index) => {
                  return (
                    <TableRow
                      key={
                        showroom?._id ??
                        `${showroom?.short_name || showroom?.name}-${index}`
                      }
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box>
                            <Typography
                              style={{
                                maxWidth: 200,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                            >
                              {showroom?.name}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box
                            sx={{
                              ml: 3,
                            }}
                          >
                            <Typography
                              style={{
                                maxWidth: 400,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                              dangerouslySetInnerHTML={{
                                __html: showroom?.address,
                              }}
                            />
                          </Box>
                        </Box>
                      </TableCell>
                      {/* <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box>
                            <Typography
                              style={{
                                maxWidth: 200,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                            >
                              {showroom?._id}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell> */}
                      <TableCell align="left" component="th" scope="row">
                        <Box
                          className="origin_des"
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            style={{
                              maxWidth: 200,
                              overflow: "hidden",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            className="font600 fs_14"
                          >
                            {/* {showroom?._id} */}
                            {showroom?.zoho_id}
                          </Typography>

                          {showroom?._id && (
                            <Tooltip title="Copy ID">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  navigator.clipboard.writeText(showroom._id);
                                  toast.success("ID copied to clipboard!");
                                }}
                              >
                                <ContentCopyIcon fontSize="inherit" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </TableCell>

                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Rating
                            style={{ width: "max-content" }}
                            name="simple-controlled"
                            value={showroom.rating}
                            disabled
                          />
                        </Box>
                      </TableCell>

                      <TableCell
                        align="left"
                        onClick={() =>
                          handleModal(true, {
                            ...showroom,
                            index,
                          })
                        }
                      >
                        <EditIcon />
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() => handleRemove(index)}
                      >
                        <DeleteIcon />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <ToastContainer />
      <AddShowRoomModal
        open={showStoreModal}
        handleClose={() => setShowStoreModal(false)}
        selectedStore={selectedStore}
        handleStore={handleStore}
        storeType={storeType}
      />
    </>
  );
};

export default ShowroomAccordian;
